import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(authed)/_layout/reports")({
  component: ReportsLayout,
  loader: () => ({
    crumb: "Reports",
  }),
});

function ReportsLayout() {
  return <Outlet />;
}
